<template>
  <span class="svg-content-lock">
  <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 35 38" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" :fill="color" clip-rule="evenodd" d="M7.49967 15.666H5.83301C3.07158 15.666 0.833008 17.9046 0.833008 20.666V32.3327C0.833008 35.0941 3.07158 37.3327 5.83301 37.3327H29.1663C31.9278 37.3327 34.1663 35.0941 34.1663 32.3327V20.666C34.1663 17.9046 31.9278 15.666 29.1663 15.666H27.4997V10.666C27.4997 5.14317 23.0225 0.666016 17.4997 0.666016C11.9768 0.666016 7.49967 5.14317 7.49967 10.666V15.666ZM10.833 15.666H24.1663V10.666C24.1663 6.98412 21.1816 3.99935 17.4997 3.99935C13.8178 3.99935 10.833 6.98412 10.833 10.666V15.666ZM25.833 18.9993H29.1663C30.0868 
    18.9993 30.833 19.7455 30.833 20.666V32.3327C30.833 33.2532 30.0868 33.9993 29.1663 33.9993H5.83301C4.91253 33.9993 4.16634 33.2532 4.16634 32.3327V20.666C4.16634 19.7455 4.91253 18.9993 5.83301 18.9993H9.16634H25.833Z"/>
  </svg>
</span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean }
  }
}
</script>